export default "__VITE_ASSET__DIsz0JIe__"